// ============================================================================
// TENANT USER SERVICE - Digital Approval System
// ============================================================================
// Talks to the tenant-scoped user endpoints (admin password reset for any
// user belonging to the current tenant).

import { get, put } from '../client/axiosClient';
import { tenantUserEndpoints } from '../endpoints/tenantUsers.endpoints';
import { appendQueryParams } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  EmptyResponse,
  ID,
  TenantUserListResponse,
  TenantUserQueryParameters,
  AdminResetPasswordRequest,
} from '../types';

/**
 * Tenant User Service Class
 */
class TenantUserService {
  /**
   * List all users belonging to the given tenant (paginated)
   */
  async list(
    tenantId: ID,
    params?: TenantUserQueryParameters
  ): Promise<TenantUserListResponse> {
    const endpoint = params
      ? appendQueryParams(tenantUserEndpoints.list(tenantId), params)
      : tenantUserEndpoints.list(tenantId);

    const response = await get<ApiResponse<TenantUserListResponse>>(endpoint);
    return response.data.data;
  }

  /**
   * Admin reset of a tenant user's password
   */
  async resetPassword(
    tenantId: ID,
    userId: ID,
    payload: AdminResetPasswordRequest
  ): Promise<EmptyResponse> {
    const response = await put<EmptyResponse>(
      tenantUserEndpoints.resetPassword(tenantId, userId),
      payload
    );
    return response.data;
  }
}

export const tenantUserService = new TenantUserService();
export default tenantUserService;
